<!-- @format -->

<template>
	<el-radio-group v-if="!isShowValue" :key="options.paramsType" v-model="value">
		<el-radio v-for="item in params" :key="item.value" :label="item.value">
			{{ item.label }}
		</el-radio>
	</el-radio-group>
	<template v-else>
		<div class="show-value">
			<el-tag v-for="itm in typeof value === 'string' ? value.split(',') : value" :key="itm">
				{{ getValue(params, itm) }}
			</el-tag>
		</div>
	</template>
</template>

<script setup lang="ts">
	import { getCache, setCache } from '@/utils/util';
	import { useDictList } from '@/api/dict/data';

	interface Props {
		modelValue: string | number | boolean | (string | number | boolean)[] | undefined | null;
		options: Record<string, any>;
		isShowValue?: boolean; // 只展示值
		isShowDefault?: boolean;
	}

	const props = withDefaults(defineProps<Props>(), {
		modelValue: null,
		isShowDefault: true,
		options: () => ({
			params: [],
		}),
	});

	const emit = defineEmits(['update:modelValue']);

	const citeList = ref<
		{
			label: string;
			value: string;
		}[]
	>([]);

	const defaultValue = computed(() => {
		return props.options.defaultValue;
	});

	const params = computed(() =>
		props.options.paramsType && props.options.paramsType === '1' ? citeList.value : props.options.params,
	);

	const value = computed({
		get() {
			const val = props.isShowDefault && props.modelValue === null ? defaultValue.value : props.modelValue;
			return Array.isArray(val) ? (val || [])[0] : val;
		},
		set(value) {
			emit('update:modelValue', value);
		},
	});

	const getCiteList = async (dictType: string) => {
		const cacheRes = getCache('dictCache', dictType);

		if (cacheRes) {
			citeList.value = cacheRes;
		} else {
			const res = await useDictList({ dictType });
			setCache('dictCache', dictType, res);
			citeList.value = res;
		}
	};

	const getValue = (list, key) => list.find((itm) => itm.value === key)?.label;

	watch(
		[() => props.options.paramsType, () => props.options.citeType],
		([newParamsType, newCiteType]) => {
			newParamsType === '1' && newCiteType && getCiteList(newCiteType);
		},
		{
			immediate: true,
		},
	);
</script>

<style scoped>
	.show-value {
		display: flex;
		gap: 3px;
		flex-wrap: wrap;
	}
</style>
